import React from 'react'
// import styled from 'styled-components'
// import tw from 'twin.macro'

/**
 * @param {object} props
 * @param {object} props.children
 * @param {string} props.imageUrl
 * @param {string} props.imageDescription
 */
export default function SurveyIntegrationContentAndImageLayout({
  children: descriptionComponent,
  imageUrl,
  imageDescription,
}) {
  return (
    <div className="flex flex-wrap md:flex-nowrap justify-between">
      <div className="w-2/3">{descriptionComponent}</div>
      <div className="w-1/3 flex-shrink md:flex-shrink-0">
        <img src={imageUrl} alt={imageDescription} className="ui bordered image" />
      </div>
    </div>
  )
}

// const Container = styled.div`
//   ${tw`flex flex-wrap md:flex-nowrap justify-between`}

//   .images {
//     ${tw``}
//   }
// `



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyIntegrationContentAndImageLayout/index.js